import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16.5 4l-4.5 8l-4.5 -8","key":"svg-0"}],["path",{"d":"M3 4l9 16l9 -16","key":"svg-1"}]]

/**
 * IconBrandVue
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtdnVlIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xNi41IDRsLTQuNSA4bC00LjUgLTgiIC8+CiAgPHBhdGggZD0iTTMgNGw5IDE2bDkgLTE2IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/brand-vue
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandVue = createReactComponent('outline', 'brand-vue', 'BrandVue', __iconNode);

export default IconBrandVue;